/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
import {timeout} from "rxjs/operators";
declare var $:any;
declare var alertify:any;
@Component({
  templateUrl:'./sychronous.html'
})

export class Sychronous implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService,
    private fileupload:FileUpload
  ){}

  private data:any={

  }


  ngOnInit(): void {
    this.getData();
  }



  private getData():void{
    this.HttpService.getData(API.deductFail).then(res=>{
      this.data = res.data;
    })
  }

  private submit():void{
    this.HttpService.postData(API.deductFail_update,{
      "day1": this.data.day1,
      "day2":  this.data.day2,
      "day3":  this.data.day3,
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
       // this.location.back();
        alertify.success(data.status.message);
      }
    });
  }


}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/notify/sychronous.component.ts